export default __webpack_public_path__ + "static/media/forward-button-dark.5ef7921b.svg";